import QteTemplateService from '@/services/admin/qteTemplate.service'
import router from '@/router'

const state =  {
}

const getters = {
}

const actions = {
    //----------------------Template ----------------
    async searchQuoteTemplates({commit}, payload) {
        try {
            console.log(payload)
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const result = await QteTemplateService.searchQuoteTemplates(payload);
            return result
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }
    },
    async getQuoteTemplateForEdit({commit}, payload) {
        try {
            console.log(payload)
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const result = await QteTemplateService.getQuoteTemplateForEdit(payload);
            return result
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }
    },
 
    async saveQuoteTemplate({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await QteTemplateService.saveQuoteTemplate(payload);

            return response
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }

    },
    //---------------------- End Template -----------------------------
    //----------------------Template Item ----------------
     
    async updateQuoteTemplateItems({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await QteTemplateService.updateQuoteTemplateItems(payload);

            return response
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }

    },
    
    async insertQuoteTemplateItem({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await QteTemplateService.insertQuoteTemplateItem(payload);

            return response
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }

    },
    //---------------------- End Template Item -----------------------------

}

const mutations = {
}

export const adminQteTemplate = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}